import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid py-3 tp-view" }
const _hoisted_2 = { class: "row g-2 align-items-start mb-3" }
const _hoisted_3 = { class: "col-12 col-lg-auto text-center" }
const _hoisted_4 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Navegación"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "btn-group ms-lg-2 mt-2 mt-lg-0",
  role: "group",
  "aria-label": "Zoom"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "col-12 col-lg text-center text-lg-end" }
const _hoisted_14 = { class: "d-inline-flex flex-wrap gap-2 justify-content-center align-items-start" }
const _hoisted_15 = {
  class: "input-group",
  style: {"width":"260px"}
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "text-danger small mt-1 text-start"
}
const _hoisted_19 = {
  class: "input-group w-auto tp-levels",
  title: "Cuántos niveles del árbol se abren al hacer clic en un nodo"
}
const _hoisted_20 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_21 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "alert alert-info py-2 d-flex justify-content-between align-items-center"
}
const _hoisted_24 = { class: "tp-stage" }
const _hoisted_25 = {
  ref: "canvas",
  class: "tp-canvas border rounded"
}
const _hoisted_26 = {
  key: 1,
  ref: "inner",
  class: "tp-inner"
}
const _hoisted_27 = ["viewBox", "width", "height"]
const _hoisted_28 = ["x", "y", "width", "height"]
const _hoisted_29 = ["x", "y", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_binary_tree_skeleton = _resolveComponent("binary-tree-skeleton")!
  const _component_org_tree_node = _resolveComponent("org-tree-node")!
  const _component_binary_tree_empty = _resolveComponent("binary-tree-empty")!
  const _component_error_modal = _resolveComponent("error-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.atHome || _ctx.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goUp(1)))
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("i", { class: "fas fa-chevron-up me-2" }, null, -1),
            _createTextVNode("Subir Nivel ", -1)
          ]))], 8, _hoisted_5),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.atHome || _ctx.loading,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
          }, [...(_cache[22] || (_cache[22] = [
            _createTextVNode(" Ir al Inicio", -1),
            _createElementVNode("i", { class: "fas fa-angle-double-up ms-2" }, null, -1)
          ]))], 8, _hoisted_6),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.loading,
            title: "Colapsar todo",
            "aria-label": "Colapsar todo",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.collapseAll && _ctx.collapseAll(...args)))
          }, [...(_cache[23] || (_cache[23] = [
            _createElementVNode("i", { class: "fas fa-compress" }, null, -1)
          ]))], 8, _hoisted_7),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.loading,
            title: "Refrescar",
            "aria-label": "Refrescar",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-sync-alt", { 'fa-spin': _ctx.loading }])
            }, null, 2)
          ], 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.loading || !_ctx.rootReady,
            title: "Alejar",
            "aria-label": "Alejar",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
          }, [...(_cache[24] || (_cache[24] = [
            _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
          ]))], 8, _hoisted_10),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.loading || !_ctx.rootReady,
            title: "Ajustar el árbol al lienzo",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.zoomFit && _ctx.zoomFit(...args)))
          }, [...(_cache[25] || (_cache[25] = [
            _createElementVNode("i", { class: "fas fa-expand me-2" }, null, -1),
            _createTextVNode("Ajustar ", -1)
          ]))], 8, _hoisted_11),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.loading || !_ctx.rootReady,
            title: "Acercar",
            "aria-label": "Acercar",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
          }, [...(_cache[26] || (_cache[26] = [
            _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
          ]))], 8, _hoisted_12)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchInput) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Usuario / Correo",
                disabled: _ctx.loading,
                onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToUser && _ctx.goToUser(...args)), ["enter"]))
              }, null, 40, _hoisted_16), [
                [_vModelText, _ctx.searchInput]
              ]),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                disabled: !_ctx.searchInput.trim() || _ctx.loading,
                title: "Buscar",
                "aria-label": "Buscar",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goToUser && _ctx.goToUser(...args)))
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("i", { class: "fas fa-search" }, null, -1)
              ]))], 8, _hoisted_17)
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-exclamation-circle fa-fw me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.error), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "input-group-text" }, [
              _createElementVNode("i", { class: "fas fa-layer-group me-1" }),
              _createTextVNode("Abrir al clic ")
            ], -1)),
            _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.expandDepth) + " " + _toDisplayString(_ctx.expandDepth === 1 ? "nivel" : "niveles"), 1),
            _createElementVNode("ul", _hoisted_21, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                return _createElementVNode("li", { key: n }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["dropdown-item", { active: _ctx.expandDepth === n }]),
                    type: "button",
                    onClick: ($event: any) => (_ctx.expandDepth = n)
                  }, _toDisplayString(n) + " " + _toDisplayString(n === 1 ? "nivel" : "niveles"), 11, _hoisted_22)
                ])
              }), 64))
            ])
          ])
        ])
      ])
    ]),
    (_ctx.notice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("span", null, _toDisplayString(_ctx.notice), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Cerrar",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.notice = ''))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        (_ctx.loading && !_ctx.rootReady)
          ? (_openBlock(), _createBlock(_component_binary_tree_skeleton, { key: 0 }))
          : (_ctx.rootReady)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", {
                  ref: "content",
                  class: "tp-content",
                  style: _normalizeStyle(_ctx.zoomStyle)
                }, [
                  (_openBlock(), _createBlock(_component_org_tree_node, {
                    key: _ctx.rootUsername,
                    username: _ctx.rootUsername,
                    "expand-depth": _ctx.expandDepth
                  }, null, 8, ["username", "expand-depth"]))
                ], 4)
              ], 512))
            : (_openBlock(), _createBlock(_component_binary_tree_empty, { key: 2 }))
      ], 512),
      (_ctx.minimap.show && !_ctx.minimapHidden)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tp-minimap",
            style: _normalizeStyle(_ctx.minimapStyle)
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "tp-minimap-grip",
              title: "Mover el minimapa",
              "aria-label": "Mover el minimapa",
              onPointerdown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.mmDragStart && _ctx.mmDragStart(...args))),
              onPointermove: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.mmDragMove && _ctx.mmDragMove(...args))),
              onPointerup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.mmDragEnd && _ctx.mmDragEnd(...args))),
              onPointercancel: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.mmDragEnd && _ctx.mmDragEnd(...args)))
            }, [...(_cache[30] || (_cache[30] = [
              _createElementVNode("i", { class: "fas fa-up-down-left-right" }, null, -1)
            ]))], 32),
            (_openBlock(), _createElementBlock("svg", {
              class: "tp-minimap-svg",
              viewBox: `0 0 ${_ctx.minimap.w} ${_ctx.minimap.h}`,
              width: _ctx.minimap.w,
              height: _ctx.minimap.h,
              onPointerdown: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.minimapPointerDown && _ctx.minimapPointerDown(...args))),
              onPointermove: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.minimapPointerMove && _ctx.minimapPointerMove(...args))),
              onPointerup: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.minimapPointerUp && _ctx.minimapPointerUp(...args))),
              onPointercancel: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.minimapPointerUp && _ctx.minimapPointerUp(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minimap.boxes, (b, i) => {
                return (_openBlock(), _createElementBlock("rect", {
                  key: i,
                  x: b.x,
                  y: b.y,
                  width: b.w,
                  height: b.h,
                  class: "tp-mm-node"
                }, null, 8, _hoisted_28))
              }), 128)),
              _createElementVNode("rect", {
                x: _ctx.minimap.vp.x,
                y: _ctx.minimap.vp.y,
                width: _ctx.minimap.vp.w,
                height: _ctx.minimap.vp.h,
                class: "tp-mm-vp"
              }, null, 8, _hoisted_29)
            ], 40, _hoisted_27)),
            _createElementVNode("button", {
              type: "button",
              class: "tp-minimap-close",
              title: "Ocultar minimapa",
              "aria-label": "Ocultar minimapa",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.minimapHidden = true))
            }, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("i", { class: "fas fa-times" }, null, -1)
            ]))])
          ], 4))
        : (_ctx.minimap.show && _ctx.minimapHidden)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "tp-minimap-show",
              title: "Mostrar minimapa",
              "aria-label": "Mostrar minimapa",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.minimapHidden = false))
            }, [...(_cache[32] || (_cache[32] = [
              _createElementVNode("i", { class: "fas fa-map" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_error_modal, {
      title: _ctx.errorTitle,
      message: _ctx.errorMessage
    }, null, 8, ["title", "message"])
  ]))
}